import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { RightHolderSimpleFormContent } from "./components/RightHolderSimpleFormContent";

export function RightHolderCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <RightHolderSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
